import gsap from 'gsap'

export default {
  name: 'VideoOpen',
  props: ['input'],
  data() {
    return {
      currentChapter: 0,
      chapters: null,
    }
  },
  computed: {
    slideLabel() {
      return this.chapters[this.currentChapter]?.label || ''
    },
  },
  created() {
    this.chapters = JSON.parse(this.input)
  },
  mounted() {
    this.$refs.video.addEventListener('timeupdate', this.onTimeUpdate)
    this.$refs.mobilevideo.addEventListener('timeupdate', this.onTimeUpdateMobile)

    gsap.to(this.$refs.navlabel, { opacity: 1 })
  },
  methods: {
    showDesktopVideo() {
      gsap.set(this.$refs.video, { opacity: 1 })
    },
    showMobileVideo() {
      gsap.set(this.$refs.mobilevideo, { opacity: 1 })
    },
    goToChapter(chapter) {
      this.currentChapter = chapter
      this.goToCurrentChapter()
    },
    goToCurrentChapter() {
      this.$refs.video.currentTime = +this.chapters[this.currentChapter]?.time
      this.$refs.mobilevideo.currentTime = +this.chapters[this.currentChapter]?.time
    },
    onTimeUpdate() {
      const lastIndex = this.chapters.filter((v) => +v.time <= this.$refs.video.currentTime).length - 1
      this.currentChapter = lastIndex
    },
    onTimeUpdateMobile() {
      const lastIndex = this.chapters.filter((v) => +v.time <= this.$refs.mobilevideo.currentTime).length - 1
      this.currentChapter = lastIndex
    },
    onEnter(el, done) {
      gsap.set(el, { position: 'absolute', left: 0, bottom: 0 })
      gsap.fromTo(
        el,
        { x: 100, y: 0, opacity: 0 },
        {
          x: 0,
          y: 0,
          opacity: 1,
          duration: 0.5,
          onComplete: () => {
            gsap.set(el, { position: 'relative' })
            done()
          },
        }
      )
    },
    onLeave(el, done) {
      gsap.to(el, { y: 50, opacity: 0, duration: 0.5, onComplete: () => done() })
    },
  },
}
